module.exports = __webpack_public_path__ + "static/media/victoria.png";